module.exports = __webpack_public_path__ + "static/media/tab-my-unactive.453bcdcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/tab-my-unactive.png
// module id = 2025
// module chunks = 6